







// Define major variable at the top
const CART_WRAPPER_CLASS = '.cartwrapper';

// Define this globally so it's not undefined
window.CART_WRAPPER_CLASS = CART_WRAPPER_CLASS;

// DISABLED FOR CLEAN SLATE - START
/*
// Add at the top with other constants
const THRESHOLD_CONFIG = {
  STARTER_KIT_ID: '51701354955122',
  THRESHOLDS: [
    {
      amount: 5,
      type: 'ebook',
      variantId: '51693648249202',
      label: 'Exotic Fruit E-Book'
    },
    {
      amount: 100,
      type: 'shipping',
      variantId: null,
      label: 'Free Shipping'
    },
    {
      amount: 150,
      type: 'dates',
      variantId: '52551349076338',
      label: 'Caviar Lime Gift'
    }
  ]
};
*/
// DISABLED FOR CLEAN SLATE - END

// Cart State Management
class CartState {
  constructor() {
    this.data = null;
    this.lastRefreshTime = 0;
    this.minimumRefreshInterval = 300;
    this.pendingRefresh = null;
  }

  async refresh() {
    if (this.pendingRefresh) {
      return await this.pendingRefresh;
    }

    const now = Date.now();
    if (this.data && (now - this.lastRefreshTime < this.minimumRefreshInterval)) {
      return this.data;
    }

    try {
      this.pendingRefresh = fetch('/cart.js').then(async (r) => {
        if(!r.ok) throw new Error('Failed to fetch /cart.js');
        return await r.json();
      });
      this.data = await this.pendingRefresh;
      this.lastRefreshTime = now;
      return this.data;
    } catch (error) {
      throw error;
    } finally {
      this.pendingRefresh = null;
    }
  }

  get isStale() {
    return !this.data || (Date.now() - this.lastRefreshTime > this.minimumRefreshInterval);
  }
}

// Initialize cart state
window.cartState = new CartState();

// Event Consolidation
class CartEventManager {
  constructor() {
    this.updateTimer = null;
    this.updateDelay = 300;
    this.pendingUpdates = new Set();
    this.bindEvents();
  }

  bindEvents() {
    // DISABLED FOR CLEAN SLATE - START
    /*
    document.addEventListener('cartUpdated', this.handleCartEvent.bind(this));
    document.addEventListener('cart:build', this.handleCartEvent.bind(this));
    document.addEventListener('cart:refresh', this.handleCartEvent.bind(this));
    document.addEventListener('gift:completed', this.handleCartEvent.bind(this));
    */
    // DISABLED FOR CLEAN SLATE - END
  }

  handleCartEvent(event) {
    if (event.type === 'cart:build') {
      const newEvent = new CustomEvent('cart:build', {
        detail: {}
      });
      this.pendingUpdates.add({
        type: newEvent.type,
        detail: newEvent.detail,
        timestamp: Date.now()
      });
      return;
    }

    const eventDetail = event.detail || {};
    
    if (eventDetail.immediate) {
      this.processImmediateUpdate(eventDetail);
      return;
    }
    
    clearTimeout(this.updateTimer);
    
    this.pendingUpdates.add({
      type: event.type,
      detail: eventDetail,
      timestamp: Date.now()
    });

    this.updateTimer = setTimeout(() => this.processUpdates(), this.updateDelay);
  }

  async processImmediateUpdate(detail = {}) {
    try {
      const cart = detail.cartState || await window.cartState.refresh();
      const hasStarterKit = cart.items.some(item => 
        String(item.variant_id) === '51701354955122'
      );
      
      updateProgressBar(cart.total_price / 100, hasStarterKit);
      updateCartBubble(cart.item_count);
      await window.thresholdManager.checkThresholds(cart);
    } catch (error) {
      // Silent error
    }
  }

  async processUpdates() {
    try {
      const cart = await window.cartState.refresh();
      await window.thresholdManager.checkThresholds(cart);
      updateCartBubble(cart.item_count);
      this.pendingUpdates.clear();
    } catch (error) {
      // Silent error
    }
  }
}

// Initialize event manager
window.cartEventManager = new CartEventManager();

class CartUpsellManager {
  constructor(cartItemsInstance) {
    this.cartItemsInstance = cartItemsInstance;
  }
}

// Initialize
window.cartUpsellManager = new CartUpsellManager();

// Membership detection function
window.isMembershipInCart = function(cartItems) {
  return cartItems.some(item => 
    item.title.toLowerCase().includes('membership') || 
    item.variant_id === '51861376434546'
  );
};

// Ensure upsell slider is initialized when cart drawer opens
document.addEventListener('cart-drawer:open', function() {
  setTimeout(() => {
    if (typeof initializeSlider === 'function') {
      initializeSlider();
    }
    
    // Ensure membership handler is initialized
    if (typeof CartMembershipHandler !== 'undefined' && !window.membershipHandler) {
      window.membershipHandler = new CartMembershipHandler();
    }
    
  }, 100);
});

// MOBILE FIX: Also initialize upsell when cart drawer becomes active (for mobile devices)
document.addEventListener('DOMContentLoaded', function() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const isActive = cartDrawer.classList.contains('active');
          
          // Cart drawer opened - ensure upsell is initialized for mobile
          if (isActive) {
            setTimeout(() => {
              if (typeof initializeSlider === 'function') {
                console.log('🔧 Mobile: Initializing upsell slider...');
                initializeSlider();
              }
            }, 200);
          }
        }
      });
    });
    
    observer.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['class']
    });
  }
});

function updateCartBubble(itemCount) {
  const cartBubble = document.querySelector('.cart-count-bubble');
  if (cartBubble) {
    cartBubble.querySelector('span[aria-hidden="true"]').textContent = itemCount;
    cartBubble.querySelector('.visually-hidden').textContent = `${itemCount} items`;
  }
}

let currentIndex = 0;
let upsellProducts, prevButton, nextButton;

function initializeSlider() {
    // Preserve current index if slider is already initialized
    const preserveIndex = (typeof window.currentIndex !== 'undefined') ? window.currentIndex : 0;
    
    upsellProducts = document.querySelector('.upsell-products');
    prevButton = document.querySelector('.slider-prev');
    nextButton = document.querySelector('.slider-next');

    // Remove existing event listeners before adding new ones
    prevButton.removeEventListener('click', handlePrevClick);
    nextButton.removeEventListener('click', handleNextClick);
    upsellProducts.removeEventListener('touchstart', handleTouchStart);
    upsellProducts.removeEventListener('touchmove', handleTouchMove);
    upsellProducts.removeEventListener('touchend', handleTouchEnd);

    prevButton.addEventListener('click', handlePrevClick);
    nextButton.addEventListener('click', handleNextClick);
    
    upsellProducts.addEventListener('touchstart', handleTouchStart, { passive: true });
    upsellProducts.addEventListener('touchmove', handleTouchMove, { passive: false }); // Cannot be passive due to preventDefault()
    upsellProducts.addEventListener('touchend', handleTouchEnd, { passive: true });

    // Initialize upsell add to cart buttons
    const addUpsellButtons = document.querySelectorAll('.add-upsell-button');
    addUpsellButtons.forEach(button => {
      // Remove existing listener first to prevent duplicates
      button.removeEventListener('click', handleUpsellAdd);
      button.addEventListener('click', handleUpsellAdd);
    });

    // Restore the preserved index
    currentIndex = preserveIndex;
    window.currentIndex = currentIndex;
    
    updateProductView();
}

function handlePrevClick() {
    if (currentIndex > 0) {
        currentIndex--;
        updateProductView();
    }
}

function handleNextClick() {
    if (currentIndex < upsellProducts.children.length - 1) {
        currentIndex++;
        updateProductView();
    }
}

let startX, endX;

function handleTouchStart(e) {
    startX = e.touches[0].clientX;
}

function handleTouchMove(e) {
    e.preventDefault();
    endX = e.touches[0].clientX;
}

function handleTouchEnd() {
    if (startX - endX > 50) {
        handleNextClick();
    } else if (endX - startX > 50) {
        handlePrevClick();
    }
}

function updateProductView() {
    if (!upsellProducts || upsellProducts.children.length === 0) {
        return;
    }

    const productWidth = upsellProducts.children[0].offsetWidth;
    upsellProducts.style.transform = `translateX(-${productWidth * currentIndex}px)`;
    prevButton.style.display = currentIndex === 0 ? 'none' : 'block';
    nextButton.style.display = currentIndex === upsellProducts.children.length - 1 ? 'none' : 'block';
}

// Add upsell button click handler
async function handleUpsellAdd(event) {
  event.preventDefault();
  const button = event.target;
  const upsellId = button.dataset.upsellId;
  
  // Disable button immediately
  button.disabled = true;
  button.style.opacity = '0.5';
  
  try {
    // 1. First add the item
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: upsellId,
        quantity: 1,
        properties: {
          _source: 'upsell'
        }
      })
    });

    if (!response.ok) {
      throw new Error('Failed to add upsell product');
    }

    // 2. Wait for cart state to be fully updated
    await new Promise(resolve => setTimeout(resolve, 100));
    const cart = await window.cartState.refresh();
    
    // 3. Update the cart drawer directly
    const cartItems = document.querySelector('cart-drawer-items');
    if (cartItems && cartItems.fullCartRefresh) {
      await cartItems.fullCartRefresh();
    }

    // 4. Let the gift coordinator process any threshold updates
    if (window.giftCoordinator) {
      await window.giftCoordinator.checkThresholdGifts(cart);
    }

    // 5. Final cart refresh to ensure everything is in sync
    const finalCart = await window.cartState.refresh();
    
    // 6. Update UI elements
    updateProgressBar(finalCart.total_price / 100, 
      finalCart.items.some(item => String(item.variant_id) === '51701354955122')
    );
    updateCartBubble(finalCart.item_count);
    
    // 7. Show success state - change text and keep color change
    button.textContent = 'Added to cart';
    // Keep button disabled and styled to show success

  } catch (error) {
    // Re-enable button on error
    button.disabled = false;
    button.style.opacity = '1';
  }
}

document.addEventListener('DOMContentLoaded', function() {
  try {
      // Check the .cartwrapper
      const cartWrapper = document.querySelector(CART_WRAPPER_CLASS);
      if (!cartWrapper) {
      }
  } catch (err) {
  }

  initializeSlider();

  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      if (cart.item_count === 0) {
      }
      const hasStarterKit = cart.items.some(item => 
        String(item.variant_id) === '51701354955122'
      );
      
      updateProgressBar(cart.total_price / 100, hasStarterKit); 
      const activeCartInstance = document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
      if (activeCartInstance) {
        const cartUpsellManager = new CartUpsellManager(activeCartInstance);
        window.cartUpsellManager = cartUpsellManager;
      }
    })
    .catch(error => {
    });
});

// Add debounce for progress bar updates
let progressBarUpdateTimer;
function debouncedProgressBarUpdate(cartTotal, hasStarterKit) {
  clearTimeout(progressBarUpdateTimer);
  progressBarUpdateTimer = setTimeout(() => {
    const progressWrapper = document.getElementById('cart-progress-wrapper');
    if (!progressWrapper) return;

    if (hasStarterKit) {
      progressWrapper.style.display = 'none';
      const giftHeading = document.querySelector('.unlock-gifts-heading');
      if (giftHeading) {
        giftHeading.textContent = 'Nice Choice! Starter Kit Added';
        giftHeading.style.marginBottom = '10px';
      }
      return;
    }

    progressWrapper.style.display = 'block';
    const progressBar = document.getElementById('cart-progress-bar');
    const progressTracker = document.querySelector('.progress-tracker');
    const goalMessageElement = document.querySelector('.goal-message');
    const progressTexts = document.querySelectorAll('.cart-progress-dlv-inner-txt');
    
    if (!progressBar || !goalMessageElement) {
      return;
    }

    const maxThreshold = 150;
    const progressPercentage = Math.min((cartTotal / maxThreshold) * 100, 100);

    progressBar.style.width = `${progressPercentage}%`;
    if (progressTracker) {
      progressTracker.style.left = `${progressPercentage}%`;
      progressTracker.textContent = `$${cartTotal.toFixed(2)}`;
    }

    // Update achievement states
    if (cartTotal >= 5) progressTexts[0].classList.add('achieved');
    else progressTexts[0].classList.remove('achieved');
    
    if (cartTotal >= 10) progressTexts[1].classList.add('achieved');
    else progressTexts[1].classList.remove('achieved');
    
    if (cartTotal >= 100) progressTexts[2].classList.add('achieved');
    else progressTexts[2].classList.remove('achieved');
    
    if (cartTotal >= 150) progressTexts[3].classList.add('achieved');
    else progressTexts[3].classList.remove('achieved');

    // Update goal message
    if (cartTotal >= 150) {
      goalMessageElement.innerHTML = "Nice work! All gifts unlocked.";
    } else if (cartTotal < 5) {
      goalMessageElement.innerHTML = `You're <b>$${(5 - cartTotal).toFixed(2)}</b> from <b>Exotic Fruit E-Book</b>`;
    } else if (cartTotal < 10) {
      goalMessageElement.innerHTML = `You're <b>$${(10 - cartTotal).toFixed(2)}</b> from <b>Free Gift Choice</b>`;
    } else if (cartTotal < 100) {
      goalMessageElement.innerHTML = `You're <b>$${(100 - cartTotal).toFixed(2)}</b> from <b>Free Shipping</b>`;
    } else if (cartTotal < 150) {
      goalMessageElement.innerHTML = `You're <b>$${(150 - cartTotal).toFixed(2)}</b> from <b>FREE Caviar Lime Gift</b>`;
    }
  }, 100); // Small delay to ensure cart is updated
}

// Replace all direct updateProgressBar calls with the debounced version
function updateProgressBar(cartTotal, hasStarterKit) {
  debouncedProgressBarUpdate(cartTotal, hasStarterKit);
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));

   document.addEventListener('cart:build', () => {
      this.onCartUpdate();  
    });

    
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings?.min_error?.replace('[min]', event.target.dataset.min) || '';
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings?.max_error?.replace('[max]', event.target.max) || '';
    } else if (event.target.step && inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings?.step_error?.replace('[step]', event.target.step) || '';
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    // 1. If change is from our gift <select>, skip default "quantity" logic:
    if (event.target.classList.contains('my-custom-gift-select')) {
      return;
    }

    // 2. Otherwise, do normal logic
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      this.updateCartDrawer();
    } else {
      this.updateMainCart();
    }
  }

  async updateCartDrawer() {
    try {
      const response = await fetch(`${routes.cart_url}?section_id=cart-drawer`);
      const responseText = response.ok ? await response.text() : null;
      if(!response.ok || !responseText) {
        throw new Error('Failed to fetch cart drawer HTML');
      }
          const html = new DOMParser().parseFromString(responseText, 'text/html');

      // Get current and new cart states
      const currentCart = window.cartState.data;
      const newCart = await window.cartState.refresh();

      // Check if either cart is missing items array
      if (!currentCart || !newCart || !Array.isArray(currentCart.items) || !Array.isArray(newCart.items)) {
        return await this.fullCartRefresh();
      }

      // Compare cart items to determine what changed
      const changes = this.diffCartItems(currentCart.items, newCart.items);

      // Update only changed items
      if (changes.length > 0) {
        changes.forEach(change => {
          const { index, type } = change;
          
          if (type === 'removed' || type === 'missing') {
            // Remove item from DOM
            const itemToRemove = this.querySelector(`[data-index="${index}"]`);
            if (itemToRemove) {
              itemToRemove.remove();
            }
          } else if (type === 'modified' || type === 'added') {
            // Get new item HTML from the fetched template
            const newItem = html.querySelector(`[data-index="${index}"]`);
            if (newItem) {
              const existingItem = this.querySelector(`[data-index="${index}"]`);
              if (existingItem) {
                existingItem.replaceWith(newItem);
              } else {
                this.querySelector('.cart-items').appendChild(newItem);
              }
            }
          }
        });

        // Update footer separately since totals changed
        const newFooter = html.querySelector('.cart-drawer__footer');
        const currentFooter = document.querySelector('.cart-drawer__footer');
        if (newFooter && currentFooter) {
          currentFooter.replaceWith(newFooter);
        }

        // Re-initialize any necessary components
        initializeSlider();
      }

    } catch (error) {
      this.fullCartRefresh();
    }
  }

  diffCartItems(oldItems, newItems) {
    const changes = [];

    // Use dictionary lookups for speed
    // Find removed and modified items
    oldItems.forEach((oldItem, index) => {
      const newItem = newItems.find(item => item.key === oldItem.key);
      if (!newItem) {
        changes.push({ type: 'removed', index, oldKey: oldItem.key });
      } else if (JSON.stringify(oldItem) !== JSON.stringify(newItem)) {
        changes.push({ type: 'modified', index, oldKey: oldItem.key });
      }
    });

    // Find added items
    newItems.forEach((newItem, index) => {
      const oldItem = oldItems.find(item => item.key === newItem.key);
      if (!oldItem) {
        changes.push({ type: 'added', index });
      }
    });

    return changes;
  }

  // Fallback method for full refresh
  async fullCartRefresh() {
    try {
      const response = await fetch(`${routes.cart_url}?section_id=cart-drawer`);
      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
      
      // Re-initialize components after full refresh
      initializeSlider();
    } catch (error) {
    }
  }

  updateMainCart() {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
        });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        const hasStarterKit = parsedState.items.some(item => 
          String(item.variant_id) === '51701354955122'
        );
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        // FIXED: Never add is-empty class when cart has items (including build-a-box items)
        const hasItems = parsedState.item_count > 0;
        this.classList.toggle('is-empty', !hasItems);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', !hasItems);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', !hasItems);

        if (parsedState.item_count === 0) {
          const cartWrapper = document.querySelector(CART_WRAPPER_CLASS);
          if (cartWrapper) {
          }
        } else {
          const cartWrapper = document.querySelector(CART_WRAPPER_CLASS);
          if (cartWrapper) {
          }
        }

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        // Avoid updating the progress bar here
        // Call updateProgressBar separately after the cart has been updated
        updateProgressBar(parsedState.total_price / 100, hasStarterKit);

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
    const cartUpdatedEvent = new CustomEvent('cartUpdated', { detail: { message: 'Cart was updated', } }); 
    document.dispatchEvent(cartUpdatedEvent);
    
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

// Find the section that handles the continue shopping button
const emptyDrawer = document.querySelector('.drawer__inner-empty');
if (emptyDrawer) {
  emptyDrawer.addEventListener('click', function(event) {
    // Check if the clicked element is the continue shopping button
    if (event.target.closest('.button')) {
      event.preventDefault(); // Prevent default redirect
      
      // Find and close the cart drawer
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.close();
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  const continueShoppingBtn = document.querySelector('.drawer__inner-empty .button');
  if (continueShoppingBtn) {
    continueShoppingBtn.addEventListener('click', function(event) {
      event.preventDefault();
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.close();
      }
    });
  }
});

class ThresholdManager {
  constructor() {
    if (ThresholdManager.instance) {
      return ThresholdManager.instance;
    }
    ThresholdManager.instance = this;
    
    this.isProcessing = false;
    this.lastCheck = 0;
    this.minimumCheckInterval = 300; // ms between checks
    
  }

  calculateCartTotal(cart) {
    const total = cart.items.reduce((sum, item) => {
      // Exclude gift items and starter kit from total
      if (this.isGiftItem(item) || String(item.variant_id) === THRESHOLD_CONFIG.STARTER_KIT_ID) {
        return sum;
      }
      return sum + item.final_line_price;
    }, 0);

    return total / 100;
  }

  isGiftItem(item) {
    return item.properties?._gift_type || 
           item.properties?._system_added ||
           THRESHOLD_CONFIG.THRESHOLDS.some(t => 
             String(t.variantId) === String(item.variant_id)
           );
  }

  async checkThresholds(cart) {
    // Prevent concurrent checks
    if (this.isProcessing) {
      return;
    }

    // Check if we've checked recently
    const now = Date.now();
    if (now - this.lastCheck < this.minimumCheckInterval) {
      return;
    }

    this.isProcessing = true;
    this.lastCheck = now;
    let updates = {
      toAdd: [],
      toRemove: []
    };

    try {
      // Check for starter kit first
      const hasStarterKit = cart.items.some(item => 
        String(item.variant_id) === THRESHOLD_CONFIG.STARTER_KIT_ID
      );

      if (hasStarterKit) {
        this.updateUI(0, true);
        return;
      }

      const cartTotal = this.calculateCartTotal(cart);

      // Track what needs to be added/removed
      updates = {
        toAdd: [],
        toRemove: []
      };

      // Check each threshold
      for (const threshold of THRESHOLD_CONFIG.THRESHOLDS) {
        const meetsThreshold = cartTotal >= threshold.amount;
        const hasThresholdGift = cart.items.some(item => 
          String(item.variant_id) === String(threshold.variantId) &&
          item.properties?._gift_type === 'threshold_gift'
        );

        if (meetsThreshold && !hasThresholdGift && threshold.variantId) {
          updates.toAdd.push({
            variantId: threshold.variantId,
            properties: {
              _gift_type: 'threshold_gift',
              _system_added: true,
              _threshold_amount: threshold.amount,
              _threshold_label: threshold.label
            }
          });
        } else if (!meetsThreshold && hasThresholdGift) {
          const itemToRemove = cart.items.find(item => 
            String(item.variant_id) === String(threshold.variantId) &&
            item.properties?._gift_type === 'threshold_gift'
          );
          if (itemToRemove) {
            updates.toRemove.push(itemToRemove.key);
          }
        }
      }

      // Process updates
      if (updates.toRemove.length > 0) {
        for (const key of updates.toRemove) {
          await this.removeFromCart(key);
        }
      }

      if (updates.toAdd.length > 0) {
        for (const gift of updates.toAdd) {
          await this.addToCart(gift);
        }
      }

      // Update UI
      this.updateUI(cartTotal, hasStarterKit);

      if (updates.toAdd.length > 0 || updates.toRemove.length > 0) {
        // Refresh cart drawer
        const cartItems = document.querySelector('cart-drawer-items');
        if (cartItems && cartItems.fullCartRefresh) {
          await cartItems.fullCartRefresh();
        }
      }

      return updates;

    } catch (error) {
    } finally {
      this.isProcessing = false;
    }
  }

  async addToCart(gift) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: gift.variantId,
        quantity: 1,
        properties: gift.properties
      })
    });

    if (!response.ok) {
      throw new Error(`Failed to add gift ${gift.variantId}`);
    }

    return response.json();
  }

  async removeFromCart(key) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: 0
      })
    });

    if (!response.ok) {
      throw new Error(`Failed to remove gift ${key}`);
    }

    return response.json();
  }

  updateUI(cartTotal, hasStarterKit) {
    // Get all UI elements
    const progressWrapper = document.getElementById('cart-progress-wrapper');
    const progressBar = document.getElementById('cart-progress-bar');
    const progressTracker = document.querySelector('.progress-tracker');
    const goalMessageElement = document.querySelector('.goal-message');
    const progressTexts = document.querySelectorAll('.cart-progress-dlv-inner-txt');
    const giftHeading = document.querySelector('.unlock-gifts-heading');

    if (!progressWrapper) return;

    if (hasStarterKit) {
      progressWrapper.style.display = 'none';
      if (giftHeading) {
        giftHeading.textContent = 'Nice Choice! Starter Kit Added';
        giftHeading.style.marginBottom = '10px';
      }
      progressTexts.forEach(text => text.classList.remove('achieved'));
      return;
    }

    // Show progress wrapper
    progressWrapper.style.display = 'block';

    if (!progressBar || !goalMessageElement) {
      return;
    }

    // Calculate progress
    const maxThreshold = THRESHOLD_CONFIG.THRESHOLDS[THRESHOLD_CONFIG.THRESHOLDS.length - 1].amount;
    const progressPercentage = Math.min((cartTotal / maxThreshold) * 100, 100);

    // Update progress bar and tracker
    progressBar.style.width = `${progressPercentage}%`;
    if (progressTracker) {
      progressTracker.style.left = `${progressPercentage}%`;
      progressTracker.style.transform = 'translateX(-50%)'; // Center the tracker
    }

    // Update threshold indicators
    THRESHOLD_CONFIG.THRESHOLDS.forEach((threshold, index) => {
      if (progressTexts[index]) {
        // Special handling for Free Gift Choice (second text)
        if (index === 1) {
          if (cartTotal >= 10) { // $10 threshold for Free Gift Choice
            progressTexts[index].classList.add('achieved');
          } else {
            progressTexts[index].classList.remove('achieved');
          }
        } 
        // Special handling for Free Shipping (third text)
        else if (index === 2) {
          if (cartTotal >= 100) { // $100 threshold for Free Shipping
            progressTexts[index].classList.add('achieved');
          } else {
            progressTexts[index].classList.remove('achieved');
          }
        }
        else {
          // Normal threshold handling for other gifts
          if (cartTotal >= threshold.amount) {
            progressTexts[index].classList.add('achieved');
          } else {
            progressTexts[index].classList.remove('achieved');
          }
        }
      }
    });

    // Update goal message
    if (cartTotal >= maxThreshold) {
      goalMessageElement.innerHTML = "Nice work! All gifts unlocked.";
      progressTexts.forEach(text => text.classList.add('achieved'));
    } else {
      // Find next threshold, but handle Free Gift Choice specially
      let nextMessage;
      if (cartTotal < 5) {
        nextMessage = `You're <b>$${(5 - cartTotal).toFixed(2)}</b> from <b>Exotic Fruit E-Book</b>`;
      } else if (cartTotal < 10) {
        nextMessage = `You're <b>$${(10 - cartTotal).toFixed(2)}</b> from <b>Free Gift Choice</b>`;
      } else if (cartTotal < 100) {
        nextMessage = `You're <b>$${(100 - cartTotal).toFixed(2)}</b> from <b>Free Shipping</b>`;
      } else if (cartTotal < 150) {
        nextMessage = `You're <b>$${(150 - cartTotal).toFixed(2)}</b> from <b>FREE Caviar Lime Gift</b>`;
      }
      goalMessageElement.innerHTML = nextMessage;
      goalMessageElement.style.visibility = 'visible';
      goalMessageElement.style.opacity = '1';
    }
  }
}

// Initialize threshold manager
window.thresholdManager = new ThresholdManager();

// Standard membership detection function - used by all systems
window.isMembershipInCart = function(cartItems) {
  return cartItems.find(item => 
    item.variant_id === 51861376434546 || 
    (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.id === 690802950514)
  );
};

// DISABLED FOR CLEAN SLATE - START
/*
// Membership Protection: Auto-restore membership if member discounts exist without membership product
document.addEventListener('cartUpdated', async function(event) {
  try {
    // Skip if event is from membership auto-restore to prevent loops
    if (event.detail?.source === 'membership-protection') {
      return;
    }
    
    const cart = await fetch('/cart.js').then(response => response.json());
    
    // Check if any items have member-build-a-box discounts
    const hasMemberDiscounts = cart.items.some(item => 
      item.discounts && item.discounts.some(discount => 
        discount.title && discount.title.includes('member-build-a-box')
      )
    );
    
    // Check if membership product is in cart
    const membershipInCart = window.isMembershipInCart(cart.items);
    
    // If member discounts exist but no membership product → Auto-restore membership
    if (hasMemberDiscounts && !membershipInCart) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: 51861376434546,
            quantity: 1,
            selling_plan: 690802950514,
            properties: { 
              _membership: 'true',
              _membership_title: 'Auto-restored Membership'
            }
          }]
        })
      });
      
      // Force cart drawer to refresh its display
      const cartDrawer = document.querySelector('cart-drawer-items');
      if (cartDrawer && cartDrawer.fullCartRefresh) {
        cartDrawer.fullCartRefresh();
      }
      
      // Update membership widget button state
      if (typeof window.checkForMembershipAndHideWidget === 'function') {
        window.checkForMembershipAndHideWidget();
      }
      
      // Dispatch event with source to prevent loops
      document.dispatchEvent(new CustomEvent('cartUpdated', {
        detail: { 
          source: 'membership-protection',
          message: 'Membership auto-restored' 
        }
      }));
    }
    
  } catch (error) {
    // Silent error handling
  }
});
*/
// DISABLED FOR CLEAN SLATE - END

